import { render, staticRenderFns } from "./WalletCallBackIndexMain.vue?vue&type=template&id=554d650a&scoped=true"
import script from "./WalletCallBackIndexMain.vue?vue&type=script&lang=js"
export * from "./WalletCallBackIndexMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554d650a",
  null
  
)

export default component.exports